(function () {
	'use strict';

	const HORA_LIMITE = 15;
	const HORAS_ENVIO = 72;

	// MM-DD format — no year needed, works every year
	const DIAS_FESTIVOS = [
		'01-01', // Año Nuevo
		'05-01', // Día del Trabajo
		'08-15', // Asunción de la Virgen
		'10-12', // Fiesta Nacional de España
		'11-01', // Todos los Santos
		'12-06', // Día de la Constitución
		'12-25', // Navidad
	];

	function esFestivo(fecha) {
		const mes = String(fecha.getMonth() + 1).padStart(2, '0');
		const dia = String(fecha.getDate()).padStart(2, '0');
		return DIAS_FESTIVOS.includes(`${mes}-${dia}`);
	}

	function esDiaLaboral(fecha) {
		const diaSemana = fecha.getDay();
		return diaSemana !== 0 && diaSemana !== 6 && !esFestivo(fecha);
	}

	function calcularDiaEntrega() {
		const ahora = new Date();

		// Cutoff: 13:00 de hoy si aún no ha pasado, si no 13:00 de mañana
		const corte = new Date(ahora);
		if (ahora.getHours() < HORA_LIMITE) {
			corte.setHours(HORA_LIMITE, 0, 0, 0);
		} else {
			corte.setDate(corte.getDate() + 1);
			corte.setHours(HORA_LIMITE, 0, 0, 0);
		}

		// Cuenta atrás exacta hasta el corte
		const diffMs = corte - ahora;
		const horasParaPedido = Math.floor(diffMs / 3_600_000);
		const minutosParaPedido = Math.floor((diffMs % 3_600_000) / 60_000);

		// Añadir HORAS_ENVIO horas laborables desde el corte
		// setTime en ms evita ambigüedades de cambio de hora (DST)
		const fechaEnvio = new Date(corte);
		let horasAgregadas = 0;
		while (horasAgregadas < HORAS_ENVIO) {
			fechaEnvio.setTime(fechaEnvio.getTime() + 3_600_000);
			if (esDiaLaboral(fechaEnvio)) {
				horasAgregadas++;
			}
		}

		// Comprobar si la entrega es mañana (robusto ante cambios de mes/año)
		const mañana = new Date(ahora);
		mañana.setDate(mañana.getDate() + 1);
		const esEntregaManana =
			fechaEnvio.getFullYear() === mañana.getFullYear() &&
			fechaEnvio.getMonth() === mañana.getMonth() &&
			fechaEnvio.getDate() === mañana.getDate();

		// Construir texto del contador
		let contador = '';
		if (horasParaPedido > 0) {
			contador += `${horasParaPedido} ${horasParaPedido === 1 ? 'hora' : 'horas'} y `;
		}
		contador += `${minutosParaPedido} minutos`;

		const opcionesFecha = {
			weekday: 'short',
			month: 'short',
			day: 'numeric',
			timeZone: 'Europe/Madrid',
		};
		const fechaEntrega = fechaEnvio.toLocaleDateString('es-ES', opcionesFecha);

		// Mostrar "mañana" solo si la entrega es al día siguiente y hoy es lun–jue
		const diaActual = ahora.getDay();
		if (esEntregaManana && diaActual >= 1 && diaActual <= 4) {
			return `Haz el pedido antes de <span>${contador}</span>. Entrega estimada <span>mañana</span>.`;
		}
		return `Haz el pedido antes de <span>${contador}</span> y te lo entregamos en <span>24/48h</span>.`;
	}

	function init() {
		document.querySelectorAll('.entrega-item').forEach(function (el) {
			el.innerHTML = calcularDiaEntrega();
		});
	}

	// Compatible con scripts en <head defer>, inline al final del body, o cargados dinámicamente
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
